import {
  Box,
  Button,
  Divider,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import ActivitiesField from "../../Reuseables/Fields/ActivitiesField";
import CheckboxField from "../../Reuseables/Fields/CheckboxField";
import { useFormikContext } from "formik";
import { useState } from "react";
import HelpIcon from "@mui/icons-material/Help";
import AddActivitiesIntro from "../../Reuseables/Introductions/AddActivitiesIntro";
import { useTranslation } from "react-i18next";
import formModel from "../formModel";
import { Project } from "../../../types/project";

export default function DefineActivitiesStep() {
  const { t } = useTranslation();
  const { values, setFieldValue, submitForm } = useFormikContext<Project>();
  const {
    formField: { skipActivities },
  } = formModel;

  const [showActivityField, setShowActivityField] = useState(
    values.activities.length > 0 ? true : false
  );
  return (
    <Grid
      container
      mt={4}
      sx={{
        flexDirection: {
          xs: "column",
          sm: "column",
          md: "row",
          lg: "row",
        },
      }}
    >
      <Grid item xs>
        <Grid container>
          <Grid item flexGrow={1} />
          <Grid item xs={12} sm={8} md={10} lg={10} xl={8}>
            <AddActivitiesIntro />
          </Grid>
          <Grid item flexGrow={1}/>
        </Grid>
      </Grid>
      <Divider orientation="vertical" flexItem />
      <Grid item xs >
        <Grid container>
          <Grid item flexGrow={1} />
          <Grid item xs={12} sm={8} md={10} lg={10} xl={8}>     
              <Grid
                item xs
                sx={{
                  "& .MuiBox-root": { mb: 2 },
                }}
              >
                <Box>
                  <Typography>{t("projectWizard.addActivities")}</Typography>
                </Box>

                <Box>
                  <Stack direction={"row"}>
                    <Button
                      fullWidth
                      onClick={async () => {
                        setShowActivityField(true);
                      }}
                      variant={"outlined"}
                    >
                      {t("buttons.addActivities")}
                    </Button>
                    <Tooltip title={skipActivities.infoMsg3}>
                      <HelpIcon
                        style={{ cursor: "default" }}
                        sx={{ margin: 1 }}
                      />
                    </Tooltip>
                  </Stack>
                </Box>
                <Box>
                  <Stack direction={"row"}>
                    <Button
                      fullWidth
                      onClick={async () => {
                        setFieldValue(skipActivities.name, true, false);
                        // // Hack to wait for new value to get updated
                        await Promise.resolve();
                        submitForm();
                      }}
                      variant={"outlined"}
                    >
                      {values.skipLocalCoordinator
                        ? values.activities.length === 0
                          ? t(skipActivities.label1)
                          : t(skipActivities.label2)
                        : t(skipActivities.label3)}
                    </Button>
                    <Tooltip
                      title={
                        values.skipLocalCoordinator
                          ? skipActivities.infoMsg2
                          : skipActivities.infoMsg1
                      }
                    >
                      <HelpIcon
                        style={{ cursor: "default" }}
                        sx={{ margin: 1 }}
                      />
                    </Tooltip>
                  </Stack>
                </Box>
              </Grid>
        
            {showActivityField && (
              <Grid container>
                <Grid item xs>
                  <Box>
                    <ActivitiesField />
                  </Box>
                  <Box>
                    <CheckboxField
                      name={skipActivities.name}
                      label={
                        values.skipLocalCoordinator
                          ? values.activities.length === 0
                            ? skipActivities.label2
                            : skipActivities.label2
                          : skipActivities.label4
                      }
                    />
                  </Box>
                </Grid>
              </Grid>
            )}
          </Grid>
          <Grid item flexGrow={1}/>
        </Grid>
      </Grid>
    </Grid>
  );
}
